import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import NavBar from "./NavBar";
import Footer from "./Footer";
import "./Gallery.css";
import gallery1 from "./assets/gallery1.JPG";
import gallery2 from "./assets/gallery2.png";
import gallery3 from "./assets/gallery3.JPG";
import gallery4 from "./assets/gallery4.JPG";
import gallery5 from "./assets/gallery5.JPG";
import gallery6 from "./assets/gallery6.JPG";
import gallery7 from "./assets/gallery7.JPG";
import gallery8 from "./assets/gallery8.JPG";
import gallery9 from "./assets/gallery9.png";
import gallery10 from "./assets/gallery10.JPG";
import gallery11 from "./assets/gallery11.png";
import gallery12 from "./assets/gallery12.png";




function Carousel({ images }) {
  const [index, setIndex] = useState(0);
  const [transitioning, setTransitioning] = useState(true);

  const next = () => {
    setIndex((prev) => prev + 1);
    setTransitioning(true);
  };

  const prev = () => {
    setIndex((prev) => prev - 1);
    setTransitioning(true);
  };

  const handleTransitionEnd = () => {
    // If we moved onto the cloned first image
    if (index === images.length) {
      setTransitioning(false);
      setIndex(0);
    }

    // If we moved onto the cloned last image (for backwards looping)
    if (index === -1) {
      setTransitioning(false);
      setIndex(images.length - 1);
    }
  };



  return (
    <>
    <NavBar mode="gallery" />

    <div className="carousel">
      <button  className="carousel-btn left" onClick={prev}>‹</button>

      <div
        className="carousel-inner"
        style={{
          transform: `translateX(-${(index + 1) * 100}%)`,
          transition: transitioning ? "transform 0.6s ease-in-out" : "none",
        }}
        onTransitionEnd={handleTransitionEnd}
      >
        {/* Clone last image at the start */}
        <img src={images[images.length - 1]} className="carousel-image" />

        {/* Real images */}
        {images.map((img, i) => (
          <img key={i} src={img} className="carousel-image" />
        ))}

        {/* Clone first image at the end */}
        <img src={images[0]} className="carousel-image" />
      </div>

      <button  className="carousel-btn right"  onClick={next}>›</button>
    </div>
    </>
  );
}





function InfoRow({ title, text, images, reverse }) {
  return (
    <div className={`info-row ${reverse ? "reverse" : ""}`}>
      <div className="info-text-block">
  <p className="box-paragraph">{text}</p>

  <div className="info-row-btn">
    <Link to="/contact" className="contact-button">Get in Touch</Link>
  </div>
</div>
      <Carousel images={images} />
    </div>
  );
}




function Gallery() {

    const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  return (
    <>
      <NavBar currentPage="gallery" />
       <h2 className={`page-header ${visible ? "visible" : ""}`}>
        Gallery
      </h2>
      <div className="gallery-page">
        <div className="gallery-content">





          <InfoRow
            text="We can take care of any stage of the job — from base coat preparation and tiling to levelling and finishing — whether you need a full installation or just help with one part of the process."
            images={[gallery1, gallery2, gallery3]}
          />

          <InfoRow
            text="If you only need units, sinks or baths fitted, we can handle that too. Everything is installed securely, neatly and to a high standard, as a standalone service or as part of a full project. "
            images={[gallery4, gallery5, gallery6, gallery7]}
            reverse
          />

          <InfoRow
            text="We also work with all water tanks and heat‑source systems, including cylinders, heat pumps and plumbing connections. You can book us for complete system setups or individual tasks depending on what you need."
          images={[gallery8, gallery9, gallery10, gallery11, gallery12]}
          />


        </div>

      </div>
     
        <Footer />
    </>
  );
}

export default Gallery;
